
import { apiSSO } from "@rfacil/shared/services";
import axios from "axios";

export interface RespuestaDTO {
  Descripcion: string;
  Estatus: boolean;
}
export interface ContraseniasDTO
{
    Correo: string;
    PSSActual: string;
    NuevaContrasenia: string;
    ConfirmarContrasenia: string;
    clave?: string;
}
export interface ClaveRecPSSDTO
{
    Id: number;
    IdUsuario: number;
    Clave: string;
    FechaVigencia: string;
    //Fuera de tabla
    MensajeError?: string;
    Correo: string;
}


/**
 * @function RecuperarPassword
 * @description Solicita al SSO el envío de instrucciones de recuperación de contraseña al correo indicado.
 * @param correo - Correo electrónico del usuario.
 * @returns Resultado de la operación reportado por la API.
 *
 * La API expone `POST /Login/RecuperarPSS` con el correo en query (`?correo=...`) y sin cuerpo (como en Swagger).
 */
export async function RecuperarPassword(correo: string): Promise<RespuestaDTO> {
	const trimmed = correo.trim();
	try {
		const response = await apiSSO.post<RespuestaDTO>('/Login/RecuperarClave', '', {
			params: { correo: trimmed },
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			console.error(`Error de API en RecuperarPassword: ${error.response?.status} - ${error.response?.data}`, error);
			throw new Error(error.response?.data);
		} else {
			console.error('Error al recuperar el password:', error);
			throw new Error('Error inesperado al recuperar el password.');
		}
	}
}

export async function ValidateCode(data: ClaveRecPSSDTO): Promise<RespuestaDTO> {
	try {
		const response = await apiSSO.post<RespuestaDTO>('/Login/ValidarClave', data);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			console.error(`Error de API en ValidateCode: ${error.response?.status} - ${error.response?.data}`, error);
			throw new Error(error.response?.data);
		} else {
			console.error('Error al validar la clave:', error);
			throw new Error('Error inesperado al validar la clave.');
		}
	}
}


export async function RestablecerChangePassword(data: ContraseniasDTO): Promise<RespuestaDTO> {
	try {
		const response = await apiSSO.post<RespuestaDTO>('/Login/RecuperarContrasenia', data);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			console.error(`Error de API en RestablecerChangePassword: ${error.response?.status} - ${error.response?.data}`, error);
			throw new Error(error.response?.data);
		} else {
			console.error('Error al restablecer la contraseña:', error);
			throw new Error('Error inesperado al restablecer la contraseña.');
		}
	}
}
